module.exports = __webpack_public_path__ + "img/6.524ab3d0.jpg";